import {Injectable, Component, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClientModule, HttpClient, HttpParams} from '@angular/common/http';
import { Connection } from '../services/connection';

declare var google;

@Injectable({
  providedIn: 'root'
})

export class Places {

  public connection: any;
  private geocodingURL = 'https://maps.googleapis.com/maps/api/geocode/json';
  private placesURL = 'https://maps.googleapis.com/maps/api/place/details/json';
  private placesAutocompleteURL = 'https://maps.googleapis.com/maps/api/place/autocomplete/json';

  private apiKey = 'AIzaSyAK5C-T7nq6yao_zZ2plgEYEuXlT3AZ2AI';

  private googleAutoComplete: any;
  private googleGeocoding: any;

  constructor(public zone: NgZone) {
    this.googleAutoComplete = new google.maps.places.AutocompleteService();
    //this.googleGeocoding = new google.maps.geocoding
  }

  setConnection(connection) {
    this.connection = connection;
  }

  requestAutocomplete(input, predictionArray) {

    const httpParams = new HttpParams()
    .set('input',input)
    .set('key',this.apiKey);



    //alert(httpParams.toString());

    //this.connection.requestHttpGet(this.placesAutocompleteURL, httpParams, successFn, errorFn, component);

    this.googleAutoComplete.getPlacePredictions({ input: input },
    (predictions, status) => {

      //alert(JSON.stringify(predictions));
      this.zone.run(() => {

        predictions.forEach((prediction) => {
          predictionArray.push(prediction);
        });
      });



      //alert(predictionArray.length);
    });

  }

  getDetails(placeId, useGeocoding, successFn, errorFn, component) {
    console.log('Retreiving location details...');

    var url = null;
    //alert('place_id => ' + placeId);

    const httpParams = new HttpParams()
    .set('place_id', placeId)
    .set('key',this.apiKey);

    if (useGeocoding){
      console.log("Using geocoding api...");
      //alert('ok');
      url = this.geocodingURL;
      this.connection.requestHttpGet(url, httpParams, successFn, errorFn, component);

    }
    else {
      console.log("Using places api...");
      url = this.placesURL;

      if(!component.sharedService.isApp()) {
        url = this.connection.generateRequestUrl('/get_place_data_by_id');
        this.connection.requestHttpGet(url, {'place_id':placeId}, successFn, errorFn, component);
      } else {
        this.connection.requestHttpGetCapacitor(url, {'place_id':placeId, 'key':this.apiKey}, successFn, errorFn, component);
      }



    }



  }

  getDetailsByCoords(latLng, successFn, errorFn, component) {
    console.log('Retreiving location details...');

    var url = null;
    //alert('place_id => ' + placeId);

    const httpParams = new HttpParams()
    .set('latlng', latLng)
    .set('key',this.apiKey);

    url = this.geocodingURL;
    this.connection.requestHttpGet(url, httpParams, successFn, errorFn, component);

  }

}
